import './css/Portfolio.css';

import { Link } from 'react-router-dom';
import { chunk } from 'lodash';

import weddingImg1 from './images/portfolio/weddings-and-engagements/thumbnails/wedding-thumbnail-1.jpg';
import weddingImg2 from './images/portfolio/weddings-and-engagements/thumbnails/wedding-thumbnail-2.jpg';
import weddingImg3 from './images/portfolio/weddings-and-engagements/thumbnails/wedding-thumbnail-3.jpg';
import weddingImg4 from './images/portfolio/weddings-and-engagements/thumbnails/wedding-thumbnail-4.jpg';
import weddingImg5 from './images/portfolio/weddings-and-engagements/thumbnails/wedding-thumbnail-5.jpg';
import weddingImg6 from './images/portfolio/weddings-and-engagements/thumbnails/wedding-thumbnail-6.jpg';

const thumbnails = [
                    { "img": weddingImg1, "text": "1", "href": "/weddings-and-engagements-1" },
                    { "img": weddingImg2, "text": "2", "href": "/weddings-and-engagements-2" },
                    { "img": weddingImg3, "text": "3", "href": "/weddings-and-engagements-3" },
                    { "img": weddingImg4, "text": "4", "href": "/weddings-and-engagements-4" },
                    { "img": weddingImg5, "text": "5", "href": "/weddings-and-engagements-5" },
                    { "img": weddingImg6, "text": "6", "href": "/weddings-and-engagements-6" },
];

function WeddingsAndEngagements() {
    const rows = chunk(thumbnails, 2);
    return (
        <table className="portfolio">
          {
            rows.map((row, rowIndex) => (
              <tr className={(rowIndex === 0 && "header")}>
                {
                  row.map((thumbnail, index) => (
                    <td className={(index % 2 === 0 && "portfolio-left") || "portfolio-right"}>
                      <div className="thumbnail">
                        <Link to={thumbnail.href}><img src={thumbnail.img} alt={thumbnail.text}/></Link>
                      </div>
                      <Link to={thumbnail.href}>{thumbnail.text}</Link>
                    </td>
                  ))
                }
              </tr>
            ))
          }
        </table>
    );
}

export default WeddingsAndEngagements;
